import React from "react";
import { usePropertyStore } from "properties/propertyPage/PropertyContext";
import { UnitHeaderPrices } from "units/UnitHeaderPrices";
import { observer } from "mobx-react-lite";
import { unitsStore } from "units/_stores/unitsStore";
import { UnitHeaderDetails } from "units/UnitHeaderDetails";
import _ from "lodash";
import { useUnitTypeStore } from "unitTypes/_store/UnitTypeContext";
import { UnitMapper } from "units/unitMapper";

export const UnitTypeHeader = observer(() => {
    const { property } = usePropertyStore();
    const { unitType } = useUnitTypeStore();
    const listStore = unitsStore.getListStore("unit-type-" + unitType._id);
    const floors = _.groupBy(listStore.items, "floorId");

    return (
        <div className="flex flex-row flex-wrap gap-5 md:gap-0 mb-5">
            <div className={"w-full md:w-1/3 flex flex-col gap-2"}>
                <UnitHeaderPrices item={UnitMapper.toHeaderPrice(unitType, "unitType", property)} />
            </div>
            <div className={"w-full md:w-2/3"}>
                <UnitHeaderDetails
                    item={UnitMapper.toHeaderDetails(unitType, "unitType", property, Object.keys(floors).length)}
                />
            </div>
        </div>
    );
});
